let category = '';

export default function currentCategory(state = category, action) {
  switch (action.type) {
    case 'UPDATE_CATEGORY':
      state = '/' + (action.payload.startsWith('/') ? action.payload.slice(1,) : action.payload);
      return state;
    default:
      return state
  }
}